import React from "react";
import { Logo } from "./Logo";

export function Header() {
  return (
    <header className="site-header">
      <div className="wrap header-inner">
        <Logo />
        <nav className="header-nav" aria-label="Navigation principale">
          <a href="/a-propos">À propos</a>
          <a href="/contact">Contact</a>
        </nav>
      </div>
    </header>
  );
}
